import { Product, Ingredient } from '../types'

export const SAMPLE_INGREDIENTS: Omit<Ingredient, 'id' | 'createdAt'>[] = [
  {
    name: 'Vollmilch',
    allergens: ['milk'], // Will be detected automatically
  },
  {
    name: 'Lab',
    allergens: [],
  },
  {
    name: 'Salz',
    allergens: [],
  },
  {
    name: 'Bakterienkulturen',
    allergens: [],
  },
]

export function createSampleData(): {
  ingredients: Ingredient[]
  product: Product
} {
  // Create ingredients with IDs
  const ingredients: Ingredient[] = SAMPLE_INGREDIENTS.map((ing) => ({
    ...ing,
    id: crypto.randomUUID(),
    createdAt: new Date().toISOString(),
  }))

  // Create cheese product using the ingredient IDs
  const product: Product = {
    id: crypto.randomUUID(),
    name: 'Gouda Käse',
    ingredientIds: ingredients.map((i) => i.id),
    labels: [], // Initialize empty labels array
    createdAt: new Date().toISOString(),
  }

  return { ingredients, product }
}
